import { useStepsContext } from '../context/StepsContext'
import useRequests from '../hooks/useRequests'
import Button from './Button'

interface Props {
  storeForm: string
  procedure: 'portabilidad' | 'portabilidadPY' | 'activationPP' | 'nominativity'
}

const IdButton = ({ storeForm, procedure }: Props) => {
  const { idStep, setIdStep }: any = useStepsContext()
  const { validity } = useRequests(storeForm)

  const continueManualValidation = () => {
    setIdStep(idStep + 1)
  }

  return (
    <>
      {procedure === 'nominativity' && (
        <Button
          id="continue-step-id-validation"
          className="submit-button btn-margin-down"
          label="Continuar"
          validity={validity}
          handleSubmit={continueManualValidation}
        />
      )}
    </>
  )
}

export default IdButton
